// Common Used Utils

// Format Registration Numbers: Separates characters and numbers with a space.
export const formatRegNo = (regNo: string | null | undefined): string =>
    regNo ? regNo.replace(/[a-z](?=\d)|\d(?=[a-z])/gi, '$& ').toUpperCase() : '';

/* Format Duration: Takes in months, outputs years and months. */
export const formatDuration = (monthsCount: number): string => {
    const years = Math.floor(monthsCount / 12);
    let yearsDur = years > 0 ? `${years} år` : '';
    yearsDur = years > 1 ? `${yearsDur}` : yearsDur;

    const restMonths = monthsCount - years * 12;
    let monthsDur = restMonths > 0 ? `${restMonths} måned` : '';
    monthsDur = restMonths > 1 ? `${monthsDur}er` : monthsDur;

    const and = years > 0 && restMonths > 0 ? ', og ' : '';

    return `${yearsDur}${and}${monthsDur}`;
};

// Format Percentage
export const formatPercentage = (num: number): number => +`${Math.round(Number(`${num}e+2`))}e-2`;

// Format Vehicle Info
export const formatVehicleInfo = (
    manufacturer?: string | null,
    make?: string | null,
    manufactureYear?: number | null,
) =>
    Object.values({ manufacturer, make, manufactureYear })
        .filter((val) => val)
        .join(' ');

export const customFailed = (errorName: string) => ({
    code: '',
    message: '',
    name: '',
    stack: '',
    status: 0,
    type: '',
    url: '',
    errorName,
});
